import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { CartProvider, WaitlistProvider } from './context'
import App from './App'
import './styles/global.css'

// Accessibility auditing in development
if (import.meta.env.DEV) {
  import('@axe-core/react').then(({ default: axe }) => {
    import('react-dom').then((ReactDOM) => {
      axe(React, ReactDOM, 1000)
    })
  })
}

import React from 'react'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <WaitlistProvider>
      <CartProvider>
        <App />
      </CartProvider>
    </WaitlistProvider>
  </StrictMode>
)
